angular.module('app').config(measurementUnitsRouting);

function measurementUnitsRouting($routeProvider) {
  $routeProvider.when('/measurement_units', {
    pageTitle: 'UNITS_OF_MEASURE',
    template: '<measurement-units-page></measurement-units-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'ng/company_settings',
    },
    menu: 'settings',
    accessPermission: 'index_measurementunit_accountadmin',
    authReq: true,
  });
}

measurementUnitsRouting.$inject = ['$routeProvider'];
